<app-de-wrapper *ngIf="!loading">
  <h1 class="heading">Email & phone</h1>
  <p class="info-text confirm-email-text">
    We just need to quickly verify your contact details so you can complete your
    purchase.
  </p>
  <form [formGroup]="form" id="email-and-phone-form">
    <div class="input-container">
      <zaver-animated-form-input
        [size]="'large'"
        [placeholder]="'Email address'"
        [formControlName]="'email'"
        [error]="form.controls.email.invalid && showError"
        [errorMessage]="'Please enter a valid email address'"
        [inputMode]="'email'"
        [autoComplete]="'email'"
        [inputType]="'email'"
        [errorIcon]="'assets/icon/icon_error.svg'"
      ></zaver-animated-form-input>
    </div>

    <div class="input-container">
      <zaver-animated-form-input
        [size]="'large'"
        [placeholder]="'Mobile number'"
        [formControlName]="'phoneNumber'"
        [error]="form.controls.phoneNumber.invalid && showError"
        [errorMessage]="'Please enter a valid mobile number'"
        [inputMode]="'tel'"
        [autoComplete]="'tel'"
        [inputType]="'tel'"
        [errorIcon]="'assets/icon/icon_error.svg'"
      ></zaver-animated-form-input>
    </div>
  </form>

  <app-general-error
    style="margin-top: 8px"
    *ngIf="form.valid && noResponseError"
  ></app-general-error>

  <div class="footer-wrapper">
    <div class="footer-container">
      <div class="total-amount" *ngIf="state.totalCheckoutValue">
        <p>Total amount:</p>
        <p>{{ state.totalCheckoutValue | value }}</p>
      </div>

      <div>
        <zaver-primary-button
          [buttonType]="'submit'"
          [formId]="'email-and-phone-form'"
          [text]="'Continue'"
          (click)="handleCtaClick()"
        ></zaver-primary-button>
      </div>
      <div style="display: flex; justify-content: center; margin-top: 16px">
        <zaver-button-link
          [text]="'View details'"
          (click)="openModalWithTerms()"
        ></zaver-button-link>
      </div>
    </div>
  </div>
  <div class="disclaimer-paragraph">
    By continuing, I agree to Zaver's terms and conditions
    <a
      class="disclaimer-link"
      target="_blank"
      href="https://zaver.com/terms-and-conditions"
      >Zaver's terms and conditions</a
    >
  </div>

  <zaver-checkout-modal
    *ngIf="modalActive"
    [buttonText]="'Close'"
    [logo]="'assets/img/Zaver_Logotype_Circle_Coal_DE.svg'"
    (onClose)="deactivateModal()"
  >
    <app-selector
      #selector
      *ngIf="!!selectorItems"
      [selectorItems]="selectorItems"
      [selectedItem]="selectedItem"
    ></app-selector>
  </zaver-checkout-modal>
</app-de-wrapper>
